// src/render/shake.ts -- render layer, uses Math.random() (cosmetic only)

export interface ShakeState {
  intensity: number;  // current shake magnitude in pixels
  duration: number;   // remaining time in seconds
  decay: number;      // decay rate (intensity per second)
}

export const shake: ShakeState = { intensity: 0, duration: 0, decay: 0 };

/** Trigger screen shake scaled to blast size. Larger blast = stronger shake. */
export function triggerShake(blastRadius: number): void {
  const magnitude = Math.min(blastRadius * 0.2, 14); // max 14px shake for nukes
  const duration = Math.min(0.2 + blastRadius * 0.004, 0.6); // longer shake for bigger blasts
  if (magnitude > shake.intensity) {
    shake.intensity = magnitude;
    shake.duration = duration;
    shake.decay = magnitude / duration;
  }
}

/** Update shake and return pixel offset for this frame. */
export function updateShake(dt: number): { dx: number; dy: number } {
  if (shake.intensity <= 0) return { dx: 0, dy: 0 };

  shake.intensity -= shake.decay * dt;
  shake.duration -= dt;

  if (shake.duration <= 0 || shake.intensity <= 0) {
    shake.intensity = 0;
    return { dx: 0, dy: 0 };
  }

  // Random offset within current intensity (cosmetic, not seeded)
  const dx = (Math.random() * 2 - 1) * shake.intensity;
  const dy = (Math.random() * 2 - 1) * shake.intensity;
  return { dx: dx | 0, dy: dy | 0 };
}
